import React, { useEffect } from "react";
import "./phDashboard.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Button, Card, Popover, Table, message } from "antd";
import { useState } from "react";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import AxiosInstance from "../../AxiosInstance";
import OtherPageHeader from "../../components/OtherHeader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import RoleSwitch from "../Helper/RoleSwitch";
import { useForm } from "react-hook-form";
import { amountFormat } from "../../utils";
import AssignModel from "../../components/Model/AssignModel/AssignModel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CompleteProfileModel from "../../components/Model/CompleteProfileMode";
import { getIpAddress } from "../../utils/getIpAddress";

export default function PhDashboard() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const navigate = useNavigate();
  var [loading, setLoading] = useState(true);
  var [policies, setPolicies] = useState([]);
  var [userRoles, setUserRoles] = useState([]);
  var [userMeData, setUserStatus] = useState("");
  var [dataSource, setDataSource] = useState([]);
  const [showReject, setShowReject] = useState(false);
  var [summaryData, setSummaryData] = useState([]);
  const [rejectionReason] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const [partnerCodeModal, setPartnerCodeModal] = useState(false);
  const [skip, setSkip] = useState(0);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [active, setActive] = useState(true);
  const handleClose = () => setShowReject(false);
  const handleShow = () => setShowReject(true);
  const [messageApi, contextHolder] = message.useMessage();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });
  var [userName, setUserName] = useState("UserName");
  const getSummary = () => {
    const url = "/policy/summary";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        setSummaryData(resp.data);
      });
  };
  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          setUserStatus(resp.data);
          setUserRoles(resp.data.userRoles);
          const temp = resp.data.userRoles;
          const result = temp.filter(function (letter) {
            return letter !== resp.data.currentRole;
          });
          localStorage.setItem("id", resp.data.id);
          localStorage.setItem("roles", result);
          localStorage.setItem("currentRole", resp.data.currentRole);
          localStorage.setItem(
            "username",
            resp.data.firstName + " " + resp.data.lastName
          );
        }
      });
  };
  const updatePolicy = (policy) => {
    navigate("/policydetails", {
      state: {
        policy,
      },
    });
  };
  const loanColumns = [
    {
      title: "Lending Partner",
      dataIndex: "provider",
      key: "provider",
    },
    {
      title: "Tenure (Months)",
      dataIndex: "tenure",
      key: "tenure",
      align: "center",
    },
    {
      title: "Interest Rate per annum (*subject to change)",
      dataIndex: "interestRate",
      key: "interestRate",
      align: "center",
    },
    {
      title: "Fees",
      dataIndex: "fees",
      key: "fees",
      render: (text) => `₹${text}`,
    },
    {
      title: "Eligible loan offer amount",
      dataIndex: "eligibleAmount",
      key: "eligibleAmount",
      render: (text) => `₹${text}`,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
    },
  ];
  const policyButtons = (policy, type) => {
    if (policy["status"] === "NOT_UPDATED") {
      return (
        <button
          className="tableButton-ph"
          onClick={() => {
            updatePolicy(policy);
          }}
        >
          {"Update Details"}
        </button>
      );
    } else if (
      policy["status"] === "PENDING" ||
      policy["status"] === "SUPERVISOR_PENDING"
    ) {
      return <button className="tableButton-ph">{"Under Review"}</button>;
    } else if (policy["status"] === "REJECTED") {
      return (
        <button
          className="tableButton-ph"
          style={{ backgroundColor: "red", color: "white" }}
          onClick={() => {
            updatePolicy(policy);
          }}
        >
          {"Policy Rejected"}
        </button>
      );
    }

    // switch work only when policy is approved
    switch (type) {
      case "loan":
        if (policy["loanStatus"] === "NOT_APPLIED") {
          if (policy["eligibleLoanBankId"]) {
            const loanData = [
              {
                key: "loan-offer",
                provider: policy.loanBank?.name || "N/A", // if you included bank relation
                tenure: policy.eligibleLoanTenure,
                interestRate: `${policy.eligibleLoanInterestRate}%`,
                fees: policy.eligibleLoanFees,
                eligibleAmount: policy.eligibleLoan,
                actions: (
                  <button
                    className="tableButton-ph"
                    onClick={() => {
                      applyService("loan", policy.policyId);
                    }}
                  >
                    {"Apply"}
                  </button>
                ),
              },
            ];

            return (
  <Popover
    overlayStyle={{ textAlign: "center", width: 800 }}
    content={
      <>
        <Table
          bordered
          size="small"
          showHeader={true}
          dataSource={loanData}
          columns={loanColumns}
          pagination={false}
          rowKey={() => "unique-row"}
        />

        <p
          style={{
            marginTop: 10,
            marginBottom: 0,
            fontSize: "13px",
            fontWeight: 500,
            textAlign: "left",
          }}
        >
          <span style={{ color: "red" }}>*</span> The loan eligibility displayed is provisional and the final loan
          eligibility decision shall be determined solely by Bajaj Finance
          Limited (BFL).
        </p>
      </>
    }
    title="Loan Offer Details"
    trigger="hover"
  >
    <button className="tableButton-ph">{"View Offer"}</button>
  </Popover>
);
          }
          return <button className="tableButton-ph">{"No Offer"}</button>;
        } else if (policy["loanStatus"] === "APPLIED") {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
              onClick={() => {
                navigate("/phdashboard/loan/" + policy["loans"][0]["loanId"]);
              }}
            >
              {"Track Status"}
            </button>
          );
        } else if (policy["loanStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Request Sent to Bank"}</button>
          );
        } else if (policy["loanStatus"] === "APPROVED") {
          return <button className="tableButton-ph">{"Loan Approved"}</button>;
        } else if (policy["loanStatus"] === "REJECTED") {
          return <button className="tableButton-ph">{"Loan Rejected"}</button>;
        } else if (policy["loanStatus"] === "PAYMENT_PENDING") {
          return (
            <button className="tableButton-ph">{"Loan Under Process"}</button>
          );
        } else if (policy["loanStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Loan Disbursed"}</button>;
        }
        //  else {
        //   return (
        //     <button
        //       className="tableButton-ph"
        //       style={{ backgroundColor: "#D3D3D3" }}
        //     >
        //       {"Applied for loan"}
        //     </button>
        //   );
        // }
        break;

      case "premiumFinanceStatus":
        if (policy["premiumFinanceStatus"] === "NOT_APPLIED") {
          return (
            <button
              className="tableButton-ph"
              onClick={() => {
                applyService("premium", policy.policyId);
              }}
            >
              {"Get Premium Finance"}
            </button>
          );
        } else if (policy["premiumFinanceStatus"] === "APPLIED") {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
            >
              {"Applied"}
            </button>
          );
        } else if (policy["premiumFinanceStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Request Sent to Bank"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "APPROVED") {
          return (
            <button className="tableButton-ph">{"Financing Approved"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "REJECTED") {
          return (
            <button className="tableButton-ph">{"Financing Rejected"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "PAYMENT_PENDING") {
          return <button className="tableButton-ph">{"Under Process"}</button>;
        } else if (policy["premiumFinanceStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Disbursed"}</button>;
        }
        // else {
        //   return (
        //     <button
        //       className="tableButton-ph"
        //       style={{ backgroundColor: "#D3D3D3" }}
        //     >
        //       {"Applied for Finance"}
        //     </button>
        //   );
        // }
        break;

      case "assignmentStatus":
        if (
          policy["assignmentStatus"] === "NOT_APPLIED" ||
          policy["assignmentStatus"] === "REJECTED"
        ) {
          return (
            <button
              className="tableButton-ph"
              onClick={() => {
                applyService("assignment", policy.policyId);
              }}
            >
              {"Apply for Assignment"}
            </button>
          );
        } else if (
          policy["assignmentStatus"] === "APPLIED" ||
          policy["assignmentStatus"] === "PENDING"
        ) {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
            >
              {"Applied"}
            </button>
          );
        } else if (policy["assignmentStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Sent to Insurer"}</button>
          );
        } else if (policy["assignmentStatus"] === "APPROVED") {
          return (
            <button className="tableButton-ph">{"Request Approved"}</button>
          );
        }
        //  else if (policy["assignmentStatus"] === "REJECTED") {
        //   return (
        //     <button className="tableButton-ph">{"Request Declined"}</button>
        //   );
        // }
        else if (policy["assignmentStatus"] === "PAYMENT_PENDING") {
          return (
            <button className="tableButton-ph">{"Investor Payment Due"}</button>
          );
        } else if (policy["assignmentStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Assigned"}</button>;
        }
        //  else {
        //   return (
        //     <button
        //       className="tableButton-ph"
        //       style={{ backgroundColor: "#D3D3D3" }}
        //     >
        //       {"Applied for Assignment"}
        //     </button>
        //   );
        // }
        break;

      default:
        return <></>;
    }
  };
  var [applyServiceUrl, setApplyServiceUrl] = useState("");

  const applyService = async (serviceType, id) => {
    if (
      userMeData.status === "NOT_UPDATED" ||
      userMeData.status === "REJECTED"
    ) {
      navigate("/completephprofile");
      return;
    }
    const url = `/policy/apply/${serviceType}/${id}`;
    setApplyServiceUrl(url);

    if (serviceType === "loan" || serviceType === "premium") {
      setRequestModal(true);
      return;
    }
    if (serviceType === "assignment") {
      setPartnerCodeModal(true);
      return;
    }

    // applyServiceApiCall(url, {});
  };
  const applyServiceApiCall = (url, payload) => {
    return AxiosInstance()
      .put(url, payload)
      .then((resp) => {
        message.success("Successfully updated");
        getPolicyData(skip);
        return resp;
        // alertSuccess(resp.data.msg);
      })
      .catch((err) => {
        message.error(err.response.data.message);
        throw err;
        // alertError();
      });
  };

  const columns = [
    {
      title: "Insurer",
      dataIndex: "insurerLogo",
      key: "insurerLogo",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy["insurerLogo"]}
          />
        </>
      ),
    },

    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "center",
    },
    {
      title: "₹ Premium Amount",
      dataIndex: "annualPremium",
      key: "annualPremium",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["annualPremium"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Sum Assured",
      dataIndex: "sumAssured",
      key: "sumAssured",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["sumAssured"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Surrender Value",
      dataIndex: "surrenderValue",
      key: "surrenderValue",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["surrenderValue"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Loan Eligible",
      dataIndex: "loanEligibility",
      key: "loanEligibility",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(policy["eligibleLoan"]) ?? "N/A"}
          <br />
          {/* {
            sessionStorage.getItem("prodStageSync") === "no"
              ?  */}
              {policyButtons(policy, "loan")}
             {/* : null
          }  */}
        </div>
      ),
      align: "right",
    },
    {
      title: "₹ Premium Finance",
      dataIndex: "premiumFinance",
      key: "premiumFinanceStatus",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(policy["eligibleFinance"]) ?? "N/A"}
          <br />
          {policyButtons(policy, "premiumFinanceStatus")}
        </div>
      ),
      align: "right",
    },
    {
      title: "₹ Assignment Offer",
      dataIndex: "assignmentStatus",
      key: "assignmentStatus",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(Math.round(policy["assignmentOfferAmount"])) ?? "N/A"}
          <br />
          {policyButtons(policy, "assignmentStatus")}
        </div>
      ),
      align: "right",
    },
  ];
  let ignore = false;

  useEffect(() => {
    if (!ignore) getPolicyData(0);
    return () => {
      ignore = true;
    };
  }, []);

  const getPolicyData = async (skip) => {
    const url = `policy/policyList?take=10&skip=${skip}`;
    return AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setPolicies(data.data);
        var temp = [];
        data.data.forEach((element) => {
          temp.push({
            ...element,
            insurerLogo: element.insurer.logo,
          });
        });
        setDataSource(temp);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
        return resp;
      })
      .catch((err) => {
        throw err;
      });
    getUserMe();
    getSummary();
  };
  const change = (data) => {
    setSkip((data - 1) * 10);
    getPolicyData((data - 1) * 10);
  };

  const PolicyCard = ({ policy }) => {
    if (loading) {
      return (
        <>
          {
            <Card
              style={{ width: 300, marginTop: 100, marginRight: 10 }}
              loading={loading}
            />
          }
        </>
      );
    }
    return (
      <>
        <div className="policy-card ">
          <div className="grid-column-card">
            <div>
              <div className="card-key">Policy Number</div>
              <div className="card-value-ph">{policy.policyNumber}</div>
            </div>
            <div>
              <div className="card-key">Plan Name</div>
              <div
                className="card-value-ph"
                title={policy?.product?.productName}
              >
                {policy?.product?.productName}
              </div>
            </div>
            <img
              className="insurer-logo"
              alt="insurerlogo"
              src={policy?.insurer?.logo}
            />
          </div>
          <div className="grid-column-card">
            <div>
              <div className="card-key">Premium Amount</div>
              <div className="card-value-ph">
                ₹{amountFormat(policy?.annualPremium)}
              </div>
            </div>
            <div>
              <div className="card-key">Premium Due Date</div>
              <div className="card-value-ph">
                {policy.premiumDueDate
                  ? moment(policy?.premiumDueDate).format("DD/MM/YYYY")
                  : "-"}
              </div>
            </div>
            <div>
              <div className="card-key">Maturity Date</div>
              <div className="card-value-ph">
                {policy.maturityDate
                  ? moment(policy?.maturityDate).format("DD/MM/YYYY")
                  : "-"}
              </div>
            </div>
          </div>
          <div className=" grid-column-card d-flex justify-content-center ">
            {/* <Button
              type="default"
              onClick={() => {
                window.open("tel:900300400");
              }}
            >
              Call for Support
            </Button> */}

            <Button
              type="default"
              onClick={() => {
                if (policy.status === "NOT_UPDATED") {
                  updatePolicy(policy);
                } else if (policy.status === "APPROVED") {
                  window.open(`${policy.insurer.paymentLink}`, "_blank");
                }
              }}
            >
              {policy.status === "NOT_UPDATED"
                ? "Update Details"
                : policy.status === "PENDING" ||
                  policy.status === "SUPERVISOR_PENDING"
                ? "Under Review"
                : policy.status === "APPROVED"
                ? "Pay Premium"
                : policy.status}
            </Button>
          </div>
        </div>
      </>
    );
  };
  var SummaryComponent = () => {
    return (
      <>
        <div className="ph-summary grid-container">
          <div>
            <div>
              {" "}
              <span className="heading-ph">Policy Holder</span>
              <br />
              <span className="heading-ph ">Dashboard</span>
              <p>(Aggregate of all policies)</p>
            </div>
          </div>
          <div>
            <div className="key">Sum Assured</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalSumAssured))
                : "-"}
            </div>

            <div className="key mt-4">Assignment Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalAssignmentValue))
                : "-"}
            </div>
          </div>
          <div>
            <div className="key">Premium Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalPremiumValue))
                : "-"}
            </div>
            <div className="key mt-4">Loan Available</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalLoanAvailable))
                : "-"}
            </div>
          </div>
          <div>
            <div className="key">Surrender Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalSurrenderValue))
                : "-"}
            </div>
          </div>
        </div>
      </>
    );
  };

  const LeftArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="left-arrow-icon-container arrow-common-container"
        onClick={onClick}
      >
        <ArrowLeftOutlined />
      </div>
    );
  };
  const RightArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="right-arrow-icon-container arrow-common-container"
        onClick={onClick}
      >
        <ArrowRightOutlined />
      </div>
    );
  };
  const settings = {
    //className: "center",
    infinite: false,
    centerPadding: "160px",
    slidesToShow: isMobile ? 1 : isTabletOrMobile ? 1.5 : 4,
    swipeToSlide: true,
    speed: 300,
    rows: 1,
    arrows: true,
    nextArrow: <RightArrow />,
    prevArrow: <LeftArrow />,
  };

  return (
    <section className="tre_bg-gray position-relative">
      {contextHolder}
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />
      <div className="container">
        <div className="tre_top-summary tre_Summary overflow-hide">
          {!isMobile && <SummaryComponent />}
        </div>

        <div className="tre_policy-block">
          <button
            className="add-policys"
            onClick={() => {
              // insurerListController();
              navigate("/mypolicy");
            }}
          >
            {" "}
            <i class="fa-solid fa-plus tre_flex-hcenter text-white policy-icon "></i>{" "}
            Add Policy
          </button>
          {/* d-flex flex-wrap position-relative tre_zindex-2 */}
          <Slider {...settings}>
            {policies.map((object, i) => (
              <PolicyCard key={i} policy={object} />
            ))}
            <div
              className="tre_policyBox1 tre_flex-hcenter tre_cursor"
              onClick={() => {
                navigate("/mypolicy");
              }}
            >
              <div className="tre_policy-btn text-center">
                <i className="fa-solid fa-plus tre_flex-hcenter mt-3 mx-auto my-2 text-white tre_plus-icons"></i>
                <div className="tre_policy-txt tre_textpurple">Add Policy</div>
              </div>
            </div>
            {!isMobile && <div></div>}
          </Slider>

          <Modal show={showReject} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Reason for Rejection</Modal.Title>
            </Modal.Header>
            <Modal.Body>{rejectionReason}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={updatePolicy}>
                Update Policy
              </Button>
            </Modal.Footer>
          </Modal>
          <div>
            <Modal
              show={requestModal}
              onHide={() => {
                setRequestModal(false);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Please add Additional Information</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {
                  <form
                    id="request-form"
                    onSubmit={handleSubmit((value) => {
                      value.requestedAmount = parseInt(value.requestedAmount);
                      value.requestedDuration = parseInt(
                        value.requestedDuration
                      );
                      applyServiceApiCall(applyServiceUrl, {
                        requestedAmount: value.requestedAmount,
                        requestedDuration: value.requestedDuration,
                      }).then((resp) => {
                        console.log(resp, applyServiceUrl,
                          resp.data,"response data"
                        );
                        // Get the loanId from the response data
                        if (resp.data) {
                          getPolicyData(0).then((policyResponse) => {
                            console.log(policyResponse.data, "policyResponse data");
                            // Find the policy that was just applied for loan
                            const policyId = applyServiceUrl.split('/').pop();
                            const updatedPolicy = policyResponse.data.data.find(p => p.policyId === parseInt(policyId));
                            if (updatedPolicy && updatedPolicy.loans && updatedPolicy.loans[0]) {
                              navigate("/phdashboard/loan/" + updatedPolicy.loans[0].loanId);
                            }
                          });
                        }
                      }).catch((err) => {
                        // Error is already handled in applyServiceApiCall
                      });
                      setRequestModal(false);
                    })}
                  >
                    {" "}
                    <div className="">
                      Amount Required:{" "}
                      <input
                        className="form-control"
                        id="requestedAmount"
                        type="number"
                        required="true"
                        {...register("requestedAmount", { required: true })}
                      ></input>
                      <br />
                      Required Duration (in months):{" "}
                      <input
                        className="form-control"
                        id="requestedDuration"
                        type="number"
                        required="true"
                        {...register("requestedDuration", { required: true })}
                      ></input>
                      <div className="tre_flex-vcenter align-items-start mt-2">
                        <input
                          type="checkbox"
                          className={`form-check-input font-16 ${
                            errors.agree ? " is-invalid" : ""
                          }`}
                          id="exampleCheck1"
                          {...register("agree", {
                            required: true,
                          })}
                        />
                        <p className="ms-2">
                          I authorize <b>The Policy Exchange</b> to share my details with BFL
                          for the loan processing.
                        </p>
                      </div>
                    </div>
                  </form>
                }
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="normal-button px-3 py-2 "
                  form="request-form"
                  type="submit"
                >
                  Submit
                </button>
              </Modal.Footer>
            </Modal>
          </div>
          <AssignModel
            applyServiceApiCall={applyServiceApiCall}
            partnerCodeModal={partnerCodeModal}
            setPartnerCodeModal={setPartnerCodeModal}
            applyServiceUrl={applyServiceUrl}
          />

          {userMeData.status === "NOT_UPDATED" && (
            <CompleteProfileModel
              active={active}
              setActive={setActive}
              target={userMeData.currentRole}
            />
          )}

          <div className="policies-table">
            <Table
              bordered={true}
              loading={loading}
              className="table"
              dataSource={[...dataSource]}
              columns={columns}
              pagination={{
                pageSize: 10,
                total: paginationMetaData.count,
                onChange: change,
              }}
            />
          </div>
          <RoleSwitch userRoles={userRoles} />
        </div>
      </div>
    </section>
  );
}